import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as globals from '../../globals';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { first, firstValueFrom } from 'rxjs';
import { ConfigurationsService } from 'src/app/services/configurations.service';
import { NgForm } from '@angular/forms';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-configurations-modify',
  templateUrl: './configurations-modify.component.html',
  styleUrl: './configurations-modify.component.scss'
})
export class ConfigurationsModifyComponent implements OnInit {

  constructor(
    private configurationsService: ConfigurationsService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isAdministrator = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
  }

  async update() {
    if(!this.isAdministrator) {
      return;
    }

    try {
      this.loadingSpinner.emit(true);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          dialogTitle: globals.configuration_update,
          description: `${globals.UPDATE_WARN_ENV_VARIBLES} - ${this.configuration.key} ?`,
          cautionaryMessage: '',
          okButtonTitle: globals.update,
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        const data = {
          key: this.configuration.key,
          value: this.configuration.value
        };
        this.logger.logEvent('Configurations Update Success', { key: data.key, appType: this.selectedAppType });
        if(this.selectedAppType === 'connect') {
          const updateConnectResult = await firstValueFrom(this.configurationsService.updateConnectEnvVariables(data));
          this.displaySnackBar(updateConnectResult ? globals.configuration_update_success : globals.configuration_update_failed);
        }
        else {
          const updateCdsResult = await firstValueFrom(this.configurationsService.updateCdsEnvVariables(data));
          this.displaySnackBar(updateCdsResult ? globals.configuration_update_success : globals.configuration_update_failed);
        }
        
        this.loadingSpinner.emit(false);
        this.saved.emit();
      }
      else {
        this.displaySnackBar(globals.configuration_update_failed);
        this.loadingSpinner.emit(false);
        this.cancelled.emit();
      }
    }
    catch (exception) {
      this.logger.logException(exception);
      this.displaySnackBar(globals.configuration_update_failed);
      this.loadingSpinner.emit(false);
      this.cancelled.emit();
    }
  }

  cancel = () => {
    this.cancelled.emit();
  };

  close() {
    this.form.controls['value'].markAsUntouched();
    this.cancelled.emit();
  }

  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 3000});

  isAdministrator: boolean;
  isContributor: boolean;
  submitting = false;

  @Input() configuration: any = {};
  @Input() selectedAppType: string = '';
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;

}
